module.exports = __webpack_public_path__ + "img/sign_out_black.9e8284c7.svg";